export default "__VITE_ASSET__Bg2QIXRd__"